var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_135_11130",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 22
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.18988,
    y: 0.973145,
    width: 20.0612,
    height: 20.0612,
    fill: "url(#pattern0)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_135_11130)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.18988,
    y: 0.973145,
    width: 20.0612,
    height: 20.0612,
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_135_11130",
    transform: "scale(0.0078125)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_135_11130",
    width: 128,
    height: 128,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAACACAYAAADDPmHLAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAADsQAAA7EB9YPtSQAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAASXSURBVHic7Z3Nb1RVHIafuWCoyg5IhGIjBhsMLk0aEyTsutLoStC4M/wLCIQVGsA/gITo3gR2BENgRXSBiUYTMcaPWgH5ChFXlnZBe1yce0hoaWfu5/l6n+RN2unM6a+57/vO9M69c0EIIYQQQgghhBBCCCGEEEIIIYQQqTEY8vNx4G1gGpgAXgDGuh5KNGIBuAfcBC4B54HbVRd5ETgDPAKMFLUWgbPADkbkfeBhAINL7WoO2M8QjgJLAQwrdaMl4Air8GEAA0r9mOCDcps/fhG4E7iGXuDlwgKwG5gtyhs+RRs/J8aw25wB8ArwG8P/JRRpYYDJAngXbfwcGQDvFNidPCJPpgsq7CAQybFjgN3p86zvSYQXHhbD7yMSZqkA7vqeQnjjXgH84HsK4Y0fC+Ar31MIb1wYAM8DN4BNnocR/fIvMFFg3yY85XkY0T8ngDm3B/AZ4Btgyt88okeuAnuxB/w8Zhz4E/9vV0rdagbYxipsB74PYEipG32HDfqabAA+Q8cDpqRH5TbdQAWmgF8CGF5qphns830txoCTqA1i1CL2yO7nVmzVGqgN4lKj1K+G2iB81Ur9+ip3Rm0Qquqkfj3YnQKTFR+oNghHdZ/rJ7HbHgPMA4eAdRUXURv4VZ3UD4CDwH/lGk8seBXYVXFBtUH/qpv6l4Ery9ZasbjaIGy1kfo1DeCkNghLbaZ+JAMY1AahqO3Uj2wAJ7WBH3WV+soGMKgN+laXqa9lACe1QbfqI/WNDGBQG3SlvlLf2ABOaoN21HfqWzOAQW3QVD5S36oBnNQG1eQz9Z0YwKA2GFW+U9+ZAZzUBk9XKKnv3AAGtcFyhZT6XgzglHsbhJj6Xg1gyLcNQk197wZwyqUNQk+9NwMY0m+DGFLv1QBOqbVBTKkPwgCGdNogttQHYwCnWNsg1tQHZwBDfG0Qc+qDNIBT6G2QQuqDNoAh3DZIJfXBG8AplDZILfXRGMDgvw1STH1UBnDquw1STn2UBjDUb4PXsZ+CNurv+bp8TBViSn20BnCq0wYAbwJfYGt9+Zp/AJ8De2qsG1vqozeAoX4bODZir5XwUvl1HWJNfRIGcKrbBk2JOfVJGcDQvA2qkELqkzOAU9dtkErqkzWAwV4C52PavQ7iGHCYNK+p7H2ArjQLvEezp4V1wAHgrwD+Hhmgpv4GjlPtqeFV4BPgVgDzd6pB+UUu3Ae+BX4G/gEelLdvAjYDrwFvAFu8TOeB3AwglqHLxmWODJA5MkDmyACZIwNkjgyQOTJA5sgAmSMDZI4MkDkyQObIAJkjA2SODJA5MkDmyACZIwNkToE9pl7kyXwB3PU9hfDG7QK47nsK4Y0bBXDJ9xTCGxcH2IsI/4o9QljkgwEmC+B34JznYUT/fAnMuNTvBK7R7vl0IlzmsSfBzLr9ADPYU55F+hjgI+y5k0+cOPkTsATsQ68HUsUAx4DTa93pADBHACcuSq1qDtjPiGzHfkRaiB/LLlXTInAW+3lIKxhW9ePAW8A0MAFsRS8UQ2cBuAPcBC4D58vvhRBCCCGEEEIIIYQQQgghhBBCCJEJ/wNE8YvcFEHdNwAAAABJRU5ErkJggg=="
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/EmailIcon.fa349e49e79394379e8acffc0df01046.svg";
export { ForwardRef as ReactComponent };